/* Copyright (c) 2020 Paul Nebel */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import AnimateOnChange from 'react-animate-on-change';

import * as animationStyles from '../styles/animations.module.css';

const shouldAnimate = (props) => {
    const {
        metronomeState,
        metronomeBeat,
        metronomeCountdownTimer,
        beatDuration,
        noteIndex,
    } = props;
    let animationBeat;
    if (metronomeState === 'active') {
        animationBeat = metronomeBeat;
    } else if (metronomeState === 'intro') {
        animationBeat = 7 - metronomeCountdownTimer;
    } else {
        animationBeat = -1;
    }
    if ((animationBeat % beatDuration) === noteIndex) {
        return true;
    } else {
        return false;
    }
};

class MetronomeIndicator extends React.Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {
            ...prevState,
            metronomeBeat: nextProps.metronomeBeat,
            metronomeCountdownTimer: nextProps.metronomeCountdownTimer,
        };

        if (((nextProps.metronomeBeat >= 0) && (nextProps.metronomeBeat !== prevState.metronomeBeat)) ||
            ((nextProps.metronomeCountdownTimer !== prevState.metronomeCountdownTimer))) {
            newState.animate = shouldAnimate(nextProps);
        }

        if (nextProps.metronomeState === 'active') {
            newState.animationClassName = 'fade_green';
        } else {
            newState.animationClassName = 'fade_red';
        }

        if (!isEqual(prevState, newState)) {
            return newState;
        } else {
            return null;
        }
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            noteIndex: props.noteIndex,
            animationClassName: props.animationClassName,
            animate: false,
            metronomeBeat: -5,
            metronomeCountdownTimer: -6,
        };
    }

    shouldComponentUpdate(nextProps) {
        if (((nextProps.metronomeBeat >= 0) && (nextProps.metronomeBeat !== this.state.metronomeBeat)) ||
            ((nextProps.metronomeCountdownTimer !== this.state.metronomeCountdownTimer))) {
            return shouldAnimate(nextProps);
        } else {
            return false;
        }
    }

    render() {
        return (
            <AnimateOnChange
                customTag="div"
                baseClassName={ animationStyles['mc'] }
                animationClassName={ animationStyles[this.state.animationClassName] }
                animate={ this.state.animate }
            />
        );
    }
}

const mapStateToProps = ({
    metronomeBeat,
    metronomeState,
    metronomeCountdownTimer,
}) => {
    return {
        metronomeBeat,
        metronomeState,
        metronomeCountdownTimer,
    };
};

MetronomeIndicator.propTypes = {
    noteIndex: PropTypes.number,
    metronomeBeat: PropTypes.number,
    metronomeState: PropTypes.string,
    metronomeCountdownTimer: PropTypes.number,
    beatDuration: PropTypes.number, // number of sixteenths to the beat
    animationClassName: PropTypes.string,
};

MetronomeIndicator.defaultProps = {
    metronomeBeat: -2,
    metronomeState: 'inactive',
    noteIndex: -1,
    beatDuration: 4,
    metronomeCountdownTimer: 7,
    animationClassName: 'fade_red',
};

export default connect(
    mapStateToProps,
    null,
)(MetronomeIndicator);
